var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8458 8.7375V10.575H15.1542V8.7375H24.8458ZM12.1167 10.575H8.08333C7.31843 10.575 6.7 11.1934 6.7 11.9583V13.0417C6.7 13.3563 6.95619 13.6125 7.27083 13.6125H9.02946L9.85215 31.0323C9.85215 31.0323 9.85216 31.0324 9.85216 31.0324C9.91388 32.3467 11.0004 33.3833 12.3151 33.3833H27.6849C29.0029 33.3833 30.0861 32.3502 30.1478 31.0324C30.1478 31.0323 30.1479 31.0323 30.1479 31.0322L30.9705 13.6125H32.7292C33.0438 13.6125 33.3 13.3563 33.3 13.0417V11.9583C33.3 11.1934 32.6816 10.575 31.9167 10.575H27.8833V8.16667C27.8833 6.80593 26.7774 5.7 25.4167 5.7H14.5833C13.2226 5.7 12.1167 6.80593 12.1167 8.16667V10.575ZM27.929 13.6125L27.1381 30.3458H12.8619L12.071 13.6125H27.929Z",
    fill: "#999999",
    stroke: "#999999",
    strokeWidth: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.ab99d30f533e190bb5205f0030b588bf.svg";
export { ForwardRef as ReactComponent };